import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function PaymentMethodCCAvenueConfigurationComponent ({handleInnerFormChange,selectRazorpay}: any) {
 
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         <InputContainer
            label="Active"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event,
                'CCAvenue.IsActive',
                selectRazorpay?.CCAvenue
              );
            }}
            type="checkbox"
            value={selectRazorpay?.CCAvenue?.IsActive}
        />
     <InputContainer
                label="Merchant Id"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'CCAvenue.MerchantId',
                    selectRazorpay?.CCAvenue
                  )
                } }
                type="text"
                value={selectRazorpay?.CCAvenue?.MerchantId} />
           <InputContainer
                  label="Working Key"
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'CCAvenue.WorkingKey',
                      selectRazorpay?.CCAvenue
                    )
                  } }
                  type="text"
                  value={selectRazorpay?.CCAvenue?.WorkingKey} />
             <InputContainer
                  label="Access Code"
                  labelField="Access Code"
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'CCAvenue.AccessCode',
                      selectRazorpay?.CCAvenue
                    )
                  } }
                  type="text"
                  value={selectRazorpay?.CCAvenue?.AccessCode} />
              </div>
  }
    expandedPanel="CCAvenue Configuration Info"
    headerTitle="CCAvenue Configuration Info"
/>
    
        </>
  )
}